import { render, staticRenderFns } from "./previewFilePage.vue?vue&type=template&id=996e8fb0&scoped=true&"
import script from "./previewFilePage.vue?vue&type=script&lang=js&"
export * from "./previewFilePage.vue?vue&type=script&lang=js&"
import style0 from "./previewFilePage.vue?vue&type=style&index=0&id=996e8fb0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996e8fb0",
  null
  
)

export default component.exports